import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import variableColors from "../_App.module.scss";

const { darkColor, appBackgroundColorWhiteSmoke } = variableColors;

//* The main component
const CookieBanner = (): JSX.Element => {
  const { t } = useTranslation();

  const [isVisible, setIsVisible] = React.useState<boolean>(false);

  React.useEffect(() => {
    const isAccepted = localStorage.getItem("cookie_consent_essential");
    if (!isAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = (): void => {
    localStorage.setItem("cookie_consent_essential", "true");
    setIsVisible(false);
  };

  return (
    <React.Fragment>
      {isVisible ? (
        <div style={styles.banner}>
          <p style={styles.text}>
            <b>{t("Dbamy o Twoją prywatność.")}</b> {t("Banner-text")} <PrivacyPolicyLink fontSize={"0.875rem"} />.
          </p>
          <Button size={undefined} variant="success" onClick={handleAccept} style={{ minWidth: "118px" }}>
            {t("Rozumiem")}
          </Button>
        </div>
      ) : null}
    </React.Fragment>
  );
};

//* Styles
const styles = {
  banner: {
    position: "fixed" as const,
    bottom: 73, //* Height of the footer
    left: 0,
    right: 0,
    backgroundColor: darkColor,
    color: appBackgroundColorWhiteSmoke,
    padding: "1rem 1.5rem",
    display: "flex",
    gap: "0.5rem",
    justifyContent: "space-between",
    alignItems: "center",
    alignContent: "center",
    zIndex: 1000,
    boxShadow: `0 -2px 10px ${darkColor}`,
    fontFamily: "inherit",
  },
  text: { margin: 0, fontSize: "0.875rem", lineHeight: "1.4" },
};

export default CookieBanner;

export const PrivacyPolicyLink = ({ fontSize }: { fontSize: string }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Link to="/window/privacy-policy">
        <Button variant="link" style={{ padding: 0, fontSize: fontSize, transform: "translateY(-2px)" }}>
          {t("Polityka Prywatności")}
        </Button>
      </Link>
    </React.Fragment>
  );
};
